import React, { FC, ReactNode } from "react";
import ReactDOM from "react-dom";
import { useFavorites } from "../../utils/FavoritesUtils";
import {ReactComponent as CloseIcon} from '../coupons/Lists/assets/close.svg';
import { useTranslation } from "react-i18next";
import {useDispatch} from "react-redux";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  fixtureId: number;
  favorite: boolean | undefined;
}

export const Popup:FC<IProps> = ({ isOpen, onClose, fixtureId, favorite }) => {
  const { t } = useTranslation();
  const {isFavorite, onChange} = useFavorites(fixtureId, useDispatch(), favorite);

  const handleContinue = () => {
    onChange();
    onClose();
  }

  if (!isOpen) return null;

  return (
    <Portal>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
            <div className="bg-white text-black max-w-[540px] p-[16px] tablet:px-[61px] rounded-md">
              <div onClick={onClose} className="flex justify-end mb-4 text-[#171A1E] mr-[-35px]">
                <CloseIcon />
              </div>
              <div className="flex flex-col items-start gap-[5px]">
                <span className="block mb-4">{t("favourites.note1")}</span>
                <span className="block mb-4">{t("favourites.note2")}</span>
                <span className="block mb-4">{t("favourites.note3")}</span>
              </div>
              <div className="flex justify-center flex-row py-[12px] gap-[15px]">
                <button onClick={handleContinue} className="rounded-[16px] bg-[#90C572] text-white w-96 py-[12px] basis-[318px] shadow-[0_1px_2px_0_rgba(0,0,0,0.5)] text-[16px] font-bold uppercase">
                  {t("favourites.continue")}
                </button>
                <button onClick={onClose} className="rounded-[16px] border text-[#000] w-96 py-[12px] basis-[318px] shadow-[0_1px_2px_0_rgba(0,0,0,0.5)] text-[16px] font-bold uppercase">
                  {t("favourites.cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

interface IPortal {
  children: ReactNode
}

const Portal: FC<IPortal> = ({ children }) => {
  const portalRoot = document.body;

  return ReactDOM.createPortal(children, portalRoot);
};

export default Portal;
